exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".los-link{margin-top:16px;white-space:nowrap}.remove-top-margin{margin-top:0}.move-selection>a{text-decoration:none;color:#444;font-weight:500}.move-selection>a:active,.move-selection>a:hover{color:#eb4e00;text-decoration:underline}.move-selection>a:focus{text-decoration:underline;color:#444}.change-confirm-section{font-size:20px}.change-confirm-section h2{color:#eb4e00;border-width:0;font-weight:700;margin-bottom:0}.change-confirm-section h3{display:inline-block;border-width:0;min-width:100px;font-size:20px;color:#444;padding:0;margin:0 0 16px 16px}.change-confirm-section .value-div{display:inline-block;max-width:inherit;padding-left:16px;margin-bottom:16px;vertical-align:unset}@media (max-width:768px){.change-confirm-section .value-div{vertical-align:top}}@media (max-width:480px){.change-confirm-section .value-div{max-width:190px}}.change-confirm-section .warning{color:#eb4e00;font-size:16px;padding-bottom:8px}.connect-date-description{margin-top:-6px}.plan-price-description{font-weight:500;color:#444}", ""]);

// exports



/*****************
 ** WEBPACK FOOTER
 ** ./~/css-loader!./~/sass-loader!./src/components/Change/Change.scss
 ** module id = 1189
 ** module chunks = 0
 **/